import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UsbOutlinedSvg from "@ant-design/icons-svg/es/asn/UsbOutlined";
import AntdIcon from "../components/AntdIcon";
var UsbOutlined = function UsbOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UsbOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UsbOutlined.displayName = 'UsbOutlined';
}
export default /*#__PURE__*/React.forwardRef(UsbOutlined);